/* eslint-disable react-hooks/exhaustive-deps */
import NavbarNotAuth from './components/navbarNotAuth'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import Luoghi from './components/luoghiImperdibili'
import { useLocation } from 'react-router-dom'
import DivBottom from './components/divBottom'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function Newsletter() {

    const location = useLocation()
    const elem = location.state
    const navigate = useNavigate()

    useEffect(() => {
        if (!elem) { navigate('/newsletter') }
        if (elem.testo1) {
            document.getElementById('testoDesktop').innerHTML = elem.testo1
            document.getElementById('testoMobile').innerHTML = elem.testo1.substring(0, 500) + '....'
            document.getElementById('testo2Desktop').innerHTML = elem.testo2
            document.getElementById('testo2Mobile').innerHTML = elem.testo2.substring(0, 500) + '....'
        }
        if (elem.footer) {
            document.getElementById('footer').innerHTML = elem.footer
        }
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 500)
    }, [elem])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}

        {elem &&
            <div style={{ marginTop: '5em' }} id='top'>
                <div className='container-fluid'>
                    <p>Newsletter\{elem.id}</p>
                </div>
                <div style={{ marginTop: '1em' }} className='homePadding'>
                    <div className='titoloNews mt-1'>
                        <div>
                            <p style={{ color: 'navy' }}>{elem.created_at}</p>
                            <h2><b>{elem.titolo}</b></h2>
                            <hr />
                            <h5 style={{ fontFamily: 'verdana' }}>{elem.sottotitolo}</h5>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[1]}`} className="foto2newsletter" alt='' />
                        </div>
                    </div>

                    <p style={{ backgroundColor: 'gainsboro', padding: '10px 0', fontFamily: 'verdana' }} className='addImg text-center'>
                        {elem.fotobottom}
                    </p>
                </div>

                <div className='sfondoNewsletterDetails'>
                    {/* ------------------------------ IMMAGINE PER BACKGROUND ------------------------------ */}
                    <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/joe-woods-4Zaq5xY5M_c-unsplash.jpg`} style={{ width: '100%', height: '100%', opacity: '.2' }} alt='' />
                    <div style={{ position: 'absolute', top: '0', height: '100%', width: '100%' }}>
                        <div className='homePadding'>
                            {/* ----------------------------- TESTO PER DESKTOP ------------------------- */}
                            <p id="testoDesktop" className="bodyPadding accordionHomeDesktop" style={{ fontSize: 'large' }}>
                            </p>
                            {/* ----------------------------- TESTO PER MOBILE ------------------------- */}
                            <div className="accordionHomeMobile">
                                <p id="testoMobile" style={{ fontSize: 'large' }}>
                                </p>
                                <button id="leggiAncora1" style={{ display: 'block', margin: '0 auto', fontWeight: '600' }} onClick={() => {
                                    const xcv = document.getElementById('leggiAncora1')
                                    if (xcv.textContent === "LEGGI ANCORA") {
                                        document.getElementById('testoMobile').innerHTML = elem.testo1
                                        xcv.innerHTML = "LEGGI MENO"
                                    } else {
                                        document.getElementById('testoMobile').innerHTML = `${elem.testo1.substring(0, 580)}....`
                                        xcv.innerHTML = "LEGGI ANCORA"
                                    }
                                }}>LEGGI ANCORA
                                </button>
                            </div>
                        </div>

                        {/* -----------------------------  PRIME 2 IMMAGINI ------------------------- */}
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap', // Permette alle foto di andare a capo su schermi piccoli
                            gap: '16px',       // Crea dello spazio tra le due foto
                            justifyContent: 'center', // Centra le foto nella pagina
                            width: '100%',
                            padding: '0 5%'
                        }}>
                            <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[2]}`} className="foto3_4_5_6" alt='' />
                            <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[3]}`} className="foto3_4_5_6" alt='' />
                        </div>

                        <div className='homePadding'>
                            <hr />
                            {/* ----------------------------- TESTO2 PER DESKTOP ------------------------- */}
                            <p id="testo2Desktop" className="bodyPadding accordionHomeDesktop mt-5" style={{ fontSize: 'large' }}>
                            </p>
                            {/* ----------------------------- TESTO2 PER MOBILE ------------------------- */}
                            <div className="accordionHomeMobile">
                                <p id="testo2Mobile" style={{ fontSize: 'large' }}>
                                </p>
                                <button id="leggiAncora2" style={{ display: 'block', margin: '0 auto', fontWeight: '600' }} onClick={() => {
                                    const xcv = document.getElementById('leggiAncora2')
                                    if (xcv.textContent === "LEGGI ANCORA") {
                                        document.getElementById('testo2Mobile').innerHTML = elem.testo2
                                        xcv.innerHTML = "LEGGI MENO"
                                    } else {
                                        document.getElementById('testo2Mobile').innerHTML = `${elem.testo2.substring(0, 580)}....`
                                        xcv.innerHTML = "LEGGI ANCORA"
                                    }
                                }}>LEGGI ANCORA
                                </button>
                            </div>
                        </div>

                        {/* ----------------------------- SECONDE 2 IMMAGINI ------------------------- */}
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap', // Permette alle foto di andare a capo su schermi piccoli
                            gap: '16px',       // Crea dello spazio tra le due foto
                            justifyContent: 'center', // Centra le foto nella pagina
                            width: '100%',
                            padding: '0 5%'
                        }}>
                            <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[4]}`} className="foto3_4_5_6" alt='' />
                            <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[5]}`} className="foto3_4_5_6" alt='' />
                        </div>

                        <div className='homePadding'>
                            <hr />
                            {/* ----------------------------- FOOTER ------------------------- */}
                            <div className='footerNews mt-4'>
                                <div>
                                    <p id="footer" style={{ fontSize: 'large' }}></p>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[6]}`} style={{ maxWidth: '100%', maxHeight: '270px', marginBottom: '5px' }} alt='' />
                                </div>
                                <div>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[7]}`} style={{ maxWidth: '100%', maxHeight: '100%' }} alt='' />
                                </div>
                            </div>
                            <hr />
                            <div style={{ fontFamily: 'code', color: 'navy', fontWeight: '600', marginTop: '3em' }}>
                                {elem.nome && <p style={{ marginTop: '-10px' }}>{elem.nome}</p>}
                                {elem.ruolo && <p style={{ marginTop: '-10px' }}>{elem.ruolo}</p>}
                                {elem.email && <p style={{ marginTop: '-10px' }}>Email: {elem.email}</p>}
                                {elem.sito && <p style={{ marginTop: '-10px' }}><a href={elem.sito} target="blank">SITO WEB</a></p>}
                                <p style={{ marginTop: '-10px' }}>Per pubblicare la tua news scrivi a: zonaeventiinfo@gmail.com</p>
                            </div>
                        </div>
                        <Luoghi />
                        <DivBottom />
                        <br />
                    </div>
                </div>
            </div>
        }
    </>
    )
}
export default Newsletter